module.exports = __webpack_public_path__ + "static/media/check.02e28ed6.svg";